import { forwardRef } from 'react';
import { QUIET_ZONE, barRects, barcodeWidthIn, sizeText, skuBars } from './skuLabelRules';

const LABEL_STYLE = {
  width: '4in',
  height: '5.98in',
  boxSizing: 'border-box',
  padding: '0.25in 0.2in',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.15in',
  fontFamily: 'Arial, Helvetica, sans-serif',
  color: '#000',
  background: '#fff',
  breakInside: 'avoid',
};

/** One 4" x 6" SKU label: product name, the Code 128 barcode of the SKU, and the SKU under it. */
export function SkuLabel({ product, isLast }) {
  const sku = String(product?.sku || '').trim();
  const bars = skuBars(sku);
  const width = bars.length + QUIET_ZONE * 2;
  const widthIn = bars ? barcodeWidthIn(width) : null;
  return (
    <div
      className="sku-label"
      data-testid="sku-label"
      style={{ ...LABEL_STYLE, pageBreakAfter: isLast ? 'auto' : 'always', breakAfter: isLast ? 'auto' : 'page' }}
    >
      <div style={{ fontSize: '20px', fontWeight: 800, textAlign: 'center', lineHeight: 1.2 }}>{product?.name}</div>
      {sizeText(product) && <div style={{ fontSize: '14px' }}>{sizeText(product)}</div>}
      {bars && widthIn ? (
        <svg
          data-testid="sku-label-barcode"
          viewBox={`0 0 ${width} 1`}
          preserveAspectRatio="none"
          shapeRendering="crispEdges"
          style={{ width: `${widthIn.toFixed(4)}in`, height: '1.5in' }}
          role="img"
          aria-label={`Barcode ${sku}`}
        >
          <rect x="0" y="0" width={width} height="1" fill="#fff" />
          {barRects(bars).map((r) => (
            <rect key={r.x} x={r.x} y="0" width={r.w} height="1" fill="#000" />
          ))}
        </svg>
      ) : (
        <div style={{ fontSize: '12px' }}>No barcode</div>
      )}
      <div data-testid="sku-label-text" style={{ fontFamily: 'Courier New, monospace', fontSize: '26px', fontWeight: 700, letterSpacing: '0.04em' }}>
        {sku}
      </div>
    </div>
  );
}

/** Every label, one per printed page. */
const SkuLabels = forwardRef(function SkuLabels({ products }, ref) {
  return (
    <div ref={ref} className="sku-labels">
      {products.map((p, i) => (
        <SkuLabel key={p.id} product={p} isLast={i === products.length - 1} />
      ))}
    </div>
  );
});

export default SkuLabels;

